import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon } from 'lucide-react';
const buyers = [{
  name: 'María V.',
  location: 'México'
}, {
  name: 'Daniela L.',
  location: 'Colombia'
}, {
  name: 'Carolina L.',
  location: 'Chile'
}, {
  name: 'Sofía M.',
  location: 'Perú'
}, {
  name: 'Florencia B.',
  location: 'Argentina'
}];
export function FloatingNotification() {
  const [visible, setVisible] = useState(false);
  const [buyer, setBuyer] = useState(buyers[0]);
  useEffect(() => {
    const initial = window.setTimeout(() => setVisible(true), 5000);
    const cycle = window.setInterval(() => {
      setVisible(false);
      window.setTimeout(() => {
        setBuyer(buyers[Math.floor(Math.random() * buyers.length)]);
        setVisible(true);
      }, 850);
    }, 30000);
    return () => {
      window.clearTimeout(initial);
      window.clearInterval(cycle);
    };
  }, []);
  return <AnimatePresence data-id="element-98" data-mp="2fzj4gwboshmm">
      {visible && <motion.div initial={{
      opacity: 0,
      y: 24
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 12,
      scale: 0.97
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed bottom-4 left-4 z-50 max-w-sm md:bottom-8 md:left-8" data-id="element-99" data-mp="20wn5m3l7bzu2">
          <div className="flex items-start gap-3 rounded-2xl border border-brand-blueSoft/50 bg-white p-4 shadow-xl" data-id="element-100" data-mp="1mvasdzxfecbv">
            <div className="mt-0.5 rounded-full bg-brand-sageMist p-2" data-id="element-101" data-mp="1hyu495q87xys">
              <CheckCircle2Icon className="h-5 w-5 text-brand-greenMid" data-id="element-102" data-mp="1d5hprof9h7jr" />
            </div>
            <div data-id="element-103" data-mp="186od1y7stkkn">
              <p className="mb-1 text-xs text-brand-muted" data-id="element-104" data-mp="1887u3r1a3znh">🔔 Compra verificada • hace unos minutos</p>
              <p className="text-sm font-medium text-brand-text" data-id="element-105" data-mp="139o7doev2ju2">
                <strong data-id="element-106" data-mp="z79kmt82mzxi">{buyer.name}</strong> de {buyer.location} compró
              </p>
              <p className="text-sm font-bold text-brand-greenMid" data-id="element-107" data-mp="u7x22ko8gf0q">Kit Maestro de Biodescodificación™</p>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}